var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 88 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.497 35.22c-11.83 0-21.625 9.612-21.625 21.414a2.36 2.36 0 0 0 2.385 2.379h38.48a2.36 2.36 0 0 0 2.386-2.38c0-11.801-9.795-21.413-21.626-21.413Z",
    fill: "url(#referral_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.498 16.186c-6.583 0-12.085 5.33-12.085 11.896 0 6.567 5.502 11.897 12.085 11.897 6.583 0 12.085-5.33 12.085-11.897S37.08 16.186 30.498 16.186Z",
    fill: "url(#referral_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.699,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.754 0H56.902c-3.959 0-7.155 3.188-7.155 7.138v9.834a7.117 7.117 0 0 0 4.77 6.71v7.566c0 .952.573 1.809 1.48 2.19.858.38 1.907.19 2.575-.524l7.871-7.805 1.002-.999h13.309c3.96 0 7.155-3.188 7.155-7.138V7.138C87.91 3.188 84.713 0 80.754 0Z",
    fill: "url(#referral_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.47 54.255v9.517l-5.056 4.759H4.964L.909 63.772v-2.38c0-3.949 3.196-7.137 7.156-7.137H58.47Z",
    fill: "#E8E2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.47 63.772v19.034H3.295a2.382 2.382 0 0 1-2.385-2.38V63.773h57.562Z",
    fill: "url(#referral_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.856 59.014c-11.83 0-21.466 9.612-21.466 21.413a2.36 2.36 0 0 0 2.385 2.38h38.162a2.359 2.359 0 0 0 2.385-2.38c0-11.801-9.636-21.413-21.466-21.413Z",
    fill: "url(#referral_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.855 39.978c-6.583 0-11.925 5.33-11.925 11.897s5.342 11.897 11.925 11.897c6.583 0 11.926-5.33 11.926-11.897s-5.343-11.897-11.926-11.897Z",
    fill: "url(#referral_svg__f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral_svg__a",
    x1: -3.171,
    y1: 48.039,
    x2: 10.944,
    y2: 80.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBA1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4214BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral_svg__b",
    x1: 27.163,
    y1: 46.999,
    x2: 51.207,
    y2: 33.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral_svg__c",
    x1: 41.136,
    y1: 19.937,
    x2: 70.32,
    y2: 51.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDA9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642DD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral_svg__d",
    x1: -20.465,
    y1: 72.597,
    x2: -9.563,
    y2: 104.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#642DD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral_svg__e",
    x1: 27.435,
    y1: 71.834,
    x2: 41.62,
    y2: 103.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBA1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral_svg__f",
    x1: 57.565,
    y1: 70.792,
    x2: 81.449,
    y2: 57.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9BFF"
  })))));
};
export { SvgReferral as ReactComponent };
export default "data:image/svg+xml;base64,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";